import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const DBTCOFTN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/dbtcoftn/logo.png",
        alt: "DayBreak Treatment Center Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 1,
  state: "TN",
  departmentIds: [105, 292],
};
